import Calendar from "../../../../../../components/Calendar";
import { CalendarProvider } from "../../../../../../components/Calendar/context/provider";
import FullLoading from "../../../../../../components/FullLoading";
import useEventsByUserOrganizationId from "../../hooks/useEventsByUserOrganizationId";

interface CollaboratorCalendarProps {
  userOrganizationId?: string;
}

export default function CollaboratorCalendar({
  userOrganizationId,
}: CollaboratorCalendarProps) {
  const {
    data: events,
    loading: eventsLoading,
    error: eventsError,
  } = useEventsByUserOrganizationId(userOrganizationId);

  if (!userOrganizationId) return null;

  if (eventsLoading) return <FullLoading />;

  const filteredEvents =
    events?.eventsByUserOrganizationId.filter(
      (event): event is NonNullable<typeof event> => event !== null
    ) ?? [];

  return (
    <CalendarProvider
      events={filteredEvents}
      loading={eventsLoading}
      error={eventsError}
      onIntervalChange={() => {}}
    >
      <Calendar />
    </CalendarProvider>
  );
}
